export const Types = {
  GET_LIST_LANCAMENTOS: "lancamentos/GET_LIST_LANCAMENTOS",
  GET_LIST_LANCAMENTOS_SUCCESS: "lancamentos/GET_LIST_LANCAMENTOS_SUCCESS",
  GET_LANCAMENTOS: "lancamentos/GET_LANCAMENTOS",
  GET_LANCAMENTOS_SUCCESS: "lancamentos/GET_LANCAMENTOS_SUCCESS",
  EDIT_LANCAMENTOS: "lancamentos/EDIT_LANCAMENTOS",
  GET_EXPORT: "lancamentos/GET_EXPORT",
  ADD_LANCAMENTOS: "lancamentos/ADD_LANCAMENTOS",
  DELETE_LANCAMENTOS: "lancamentos/DELETE_LANCAMENTOS",
  DELETE_LANCAMENTOS_PARCELA: "lancamentos/DELETE_LANCAMENTOS_PARCELA",
  SEARCH_LANCAMENTOS: "lancamentos/SEARCH_LANCAMENTOS",
  CHANGE_PAGE_LANCAMENTOS: "lancamentos/CHANGE_PAGE_LANCAMENTOS",
  CHANGE_ROWS_PER_PAGE_LANCAMENTOS:
    "lancamentos/CHANGE_ROWS_PER_PAGE_LANCAMENTOS",
  GET_LIST_LANCAMENTOS_SELECTS: "lancamentos/GET_LIST_LANCAMENTOS_SELECTS",
  GET_LIST_LANCAMENTOS_SUCCESS_SELECTS:
    "lancamentos/GET_LIST_LANCAMENTOS_SUCCESS_SELECTS",
  DELETE_ALL_LANCAMENTOS: "lancamentos/DELETE_ALL_LANCAMENTOS",
  CHANGE_FILTER: "lancamentos/CHANGE_FILTER"
};

const INITIAL_STATE = {
  data: [],
  dataList: [],
  loadingSelect: false,
  item: {},
  filter: {},
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  total: 0,
  totals: {}
};

export default function lancamentos(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_LANCAMENTOS:
      return { ...state };
    case Types.GET_LIST_LANCAMENTOS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        totals: action.payload.totals
      };
    case Types.GET_LANCAMENTOS_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.GET_EXPORT:
      return { ...state };
    case Types.ADD_LANCAMENTOS:
      return { ...state };
    case Types.DELETE_LANCAMENTOS:
      return { ...state };
    case Types.DELETE_LANCAMENTOS_PARCELA:
      return { ...state };
    case Types.CHANGE_PAGE_LANCAMENTOS:
      return { ...state, page: action.payload.page };
    case Types.SEARCH_LANCAMENTOS:
      return { ...state, filter: action.payload.filter };
    case Types.CHANGE_ROWS_PER_PAGE_LANCAMENTOS:
      return { ...state, rowsPerPage: action.payload.total };
    case Types.GET_LIST_LANCAMENTOS_SELECTS:
      return { ...state, loadingSelect: true };
    case Types.GET_LIST_LANCAMENTOS_SUCCESS_SELECTS:
      return {
        ...state,
        dataList: action.payload.lancamentos,
        loadingSelect: false
      };
    case Types.CHANGE_FILTER:
      return {
        ...state,
        filter: action.payload.data
      };
    case Types.DELETE_ALL_LANCAMENTOS:
      return { ...state };
    default:
      return state;
  }
}

export const Creators = {
  getListLancamentos: () => ({
    type: Types.GET_LIST_LANCAMENTOS
  }),
  getListLancamentosSuccess: (data, total, totals) => ({
    type: Types.GET_LIST_LANCAMENTOS_SUCCESS,
    payload: { data, total, totals }
  }),
  getExport: () => ({
    type: Types.GET_EXPORT
  }),
  getLancamentos: id => ({
    type: Types.GET_LANCAMENTOS,
    payload: { id }
  }),
  getLancamentosSuccess: data => ({
    type: Types.GET_LANCAMENTOS_SUCCESS,
    payload: { data }
  }),
  editLancamentos: data => ({
    type: Types.EDIT_LANCAMENTOS,
    payload: data
  }),
  addLancamentos: data => ({
    type: Types.ADD_LANCAMENTOS,
    payload: data
  }),
  deleteLancamentos: () => ({
    type: Types.DELETE_LANCAMENTOS
  }),
  deleteLancamentosParcela: () => ({
    type: Types.DELETE_LANCAMENTOS_PARCELA
  }),
  searchLancamentos: filter => ({
    type: Types.SEARCH_LANCAMENTOS,
    payload: { filter }
  }),
  changeLancamentosPage: page => ({
    type: Types.CHANGE_PAGE_LANCAMENTOS,
    payload: { page }
  }),
  changeLancamentosRowsPerPage: total => ({
    type: Types.CHANGE_ROWS_PER_PAGE_LANCAMENTOS,
    payload: { total }
  }),
  getListLancamentosSelects: () => ({
    type: Types.GET_LIST_LANCAMENTOS_SELECTS
  }),
  getListLancamentosSuccessSelects: lancamentos => ({
    type: Types.GET_LIST_LANCAMENTOS_SUCCESS_SELECTS,
    payload: { lancamentos }
  }),
  deleteAllLancamentos: (selected, target) => ({
    type: Types.DELETE_ALL_LANCAMENTOS,
    payload: { selected, target }
  }),
  changeFilter: data => ({
    type: Types.CHANGE_FILTER,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/lancamentos.js